import { FC, memo, useEffect, useRef } from 'react'

import VideoFrame from './video-frame'

import { IMaterial } from 'constants/types/webinar.types'

import styles from './video-block.module.scss'

interface IVideoFrameMaterial {
  dataset: IMaterial
  refPlayerOuter: any
}

const VideoFrameMaterial: FC<IVideoFrameMaterial> = ({ dataset, refPlayerOuter }) => {
  const isMustBePaid = dataset?.isAcceptAllow === false //Именно false, а не undefined, например

  const refPlayer = useRef<any>(null)

  useEffect(() => {
    refPlayerOuter.current = refPlayer.current
  }, [refPlayerOuter])

  return (
    <div className={styles.translationBlock}>
      <div className={styles.videoWrapper}>
        <VideoFrame dataset={dataset} isMustBePaid={isMustBePaid} refPlayer={refPlayer} />
      </div>
    </div>
  )
}

export default memo(VideoFrameMaterial)
